import { initialState } from "us.collection.admin/reducers/ClosureCodes/State";
import { ClosureCodes } from "us.collection.admin/constants/Actions";

const {
  GET_CLOSURE_CODES,
  GET_CLOSURE_CODES_SUCCESS,
  GET_CLOSURE_CODES_FAIL,
  ADD_CLOSURE_CODES,
  ADD_CLOSURE_CODES_SUCCESS,
  ADD_CLOSURE_CODES_FAIL,
  OPEN_CLOSURE_CODE_DRAWER,
  UPDATE_CLOSURE_CODES,
  GET_CLOSURE_CODE_HISTORY,
  GET_CLOSURE_CODE_HISTORY_SUCCESS,
  GET_CLOSURE_CODE_HISTORY_FAIL,
  DELETE_CLOSURE_CODE,
  DELETE_CLOSURE_CODE_SUCCESS,
  DELETE_CLOSURE_CODE_FAIL,
} = ClosureCodes;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case GET_CLOSURE_CODES:
      return Object.assign({}, state, {
        closureCodeList: {
          data: [],
          isLoading: true,
        },
      });
    case GET_CLOSURE_CODES_SUCCESS:
      return Object.assign({}, state, {
        closureCodeList: {
          data: payload?.data,
          isLoading: false,
        },
      });
    case GET_CLOSURE_CODES_FAIL:
      return Object.assign({}, state, {
        closureCodeList: {
          ...state.closureCodeList,
          isLoading: false,
        },
      });
    case OPEN_CLOSURE_CODE_DRAWER:
      return Object.assign({}, state, {
        drawerDetails: payload?.data,
      });
    case ADD_CLOSURE_CODES:
      return Object.assign({}, state, {});
    case ADD_CLOSURE_CODES_SUCCESS:
      return Object.assign({}, state, {
        drawerDetails: initialState.drawerDetails,
      });
    case ADD_CLOSURE_CODES_FAIL:
      return Object.assign({}, state, {});
    case UPDATE_CLOSURE_CODES:
      return Object.assign({}, state, {});
    case GET_CLOSURE_CODE_HISTORY:
      return Object.assign({}, state, {
        closureCodeHistory: {
          data: [],
          isLoading: true,
        },
      });
    case GET_CLOSURE_CODE_HISTORY_SUCCESS:
      return Object.assign({}, state, {
        closureCodeHistory: {
          data: payload?.data,
          isLoading: false,
        },
      });
    case GET_CLOSURE_CODE_HISTORY_FAIL:
      return Object.assign({}, state, {
        closureCodeHistory: {
          ...state.closureCodeHistory,
          isLoading: false,
        },
      });
    case DELETE_CLOSURE_CODE:
      return Object.assign({}, state, {});
    case DELETE_CLOSURE_CODE_SUCCESS:
      return Object.assign({}, state, {});
    case DELETE_CLOSURE_CODE_FAIL:
      return Object.assign({}, state, {});
    default:
      return state;
  }
};
